export enum LoginFocusKeys {
  Memorize = 'login_memorize',
  AcessByPhone = 'login_access_phone',
  ForgotPassword = 'login_forgot_password',
  PasswordToggle = 'login_password_toggle',
}
